import { CabinetConfigurationState, ConfigurationChangeModel, RootState, CabinetConfigurationSettingsModel, StoreConstants } from '@/types';
import { ActionTree } from 'vuex';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { ObjectUtils } from '@/utils/objectUtils';

export const actions: ActionTree<CabinetConfigurationState, RootState> = {
  async [StoreConstants.CabinetConfiguration.Actions.BeginChange]({ commit, dispatch }, changeConfiguration: ConfigurationChangeModel) {
    try {
      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, true);
      const result = await CabinetConfigurationService.beginChangeAsync(changeConfiguration);
      commit(StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationChange, result);
      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, false);
    } catch (error) {
      dispatch('getChangeWithErrorPage');
    }
  },
  async [StoreConstants.CabinetConfiguration.Actions.EndChange]({ commit, dispatch, getters }) {
    try {
      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, true);
      const result = await CabinetConfigurationService.endChangeAsync(getters.cabinetConfigurationChange.id);
      commit(StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationChange, result);
      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, false);
    } catch (error) {
      dispatch('getChangeWithErrorPage');
    }
  },
  async [StoreConstants.CabinetConfiguration.Actions.GetChangeWithErrorPage]({ commit }) {
    try {
      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, true);
      const result = await CabinetConfigurationService.getChangeWithErrorPageAsync();
      commit(StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationChange, result);
    } catch (error) {
      commit(StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationChange, {} as ConfigurationChangeModel);
    } finally {
      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, false);
    }
  },
  async [StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage]({ state, commit }) {
    try {
      const settings = state.cabinetConfigurationSettings;
      if (!ObjectUtils.isNullOrEmpty(settings)) {
        return;
      }

      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, true);
      const result = await CabinetConfigurationService.getCabinetConfigurationSettingsWithErrorPageAsync();
      commit(StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationSettings, result);
    } catch (error) {
      commit(StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationSettings, {} as CabinetConfigurationSettingsModel);
    } finally {
      commit(StoreConstants.CabinetConfiguration.Mutations.SetIsLoading, false);
    }
  },
  [StoreConstants.CabinetConfiguration.Actions.SetCabientConfigurationEnableEncryptionForNewCabinets]({ state, commit }, isEncryptNewDocumentTypesEnabled: boolean) {
    commit(StoreConstants.CabinetConfiguration.Mutations.SetCabinetConfigurationSettingsIsEncryptNewDocumentTypesEnabled, isEncryptNewDocumentTypesEnabled);
  }
};
